import { create } from "zustand";

export const useCuttingPlanStatsStore = create((set) => ({
    cuttingPlanStats: {
        totalWeight: 0,
        totalWasteWeight: 0,
        preCutWeight: 0,
        orderWeight: 0,
        outageWeight: 0,
        subWeight: 0,
        yieldPercentage: 0,
        wastePercentage: 0,
        yieldExceptPreCutPercentage: 0,
        wasteExceptPreCutPercentage: 0,
        theoreticalWeight: 0,

        totalLogs: 0,
        totalWeightExceptPreCut: 0,
        orderLogs: 0,
        orderWeightExceptPreCut: 0,
        outageWeightExceptPreCut: 0,
        wastedWeight: 0,
        wastedWeightExceptPreCut: 0,
    },
    setCuttingPlanStats: (cuttingPlanStats) => set({ cuttingPlanStats }),
}));